import api from "@/lib/api";

// Requests a server-side, pixel-consistent PDF and triggers a browser download.
export async function downloadPdf({ model, brandColor = "#10B981", agencyName = "Performance Flow Pro", filename = "document" }) {
  const res = await api.post(
    "/render/pdf",
    { model, brand_color: brandColor, agency_name: agencyName, filename },
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// Server-side Gantt timeline PDF download.
export async function downloadGanttPdf({ projectName, tasks, brandColor = "#10B981", filename = "gantt" }) {
  const res = await api.post(
    "/render/gantt-pdf",
    { project_name: projectName, tasks, brand_color: brandColor, filename },
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
